import {BaseService} from './base'

class BookService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 医院科室列表
   * @param hosId
   * @returns {Promise<Array>}
   */
  async deptList(hosId) {
    const {code, list} = await this.$http('smarthos.yygh.ApiDepartmentService.oneClassDepartmentList', {hosId});
    if (code === '0') return list;
    return [];
  }

  /**
   * 平台医生关联挂号医生
   * @param docId
   * @returns {Promise<void>}
   */
  async userBookDocList(docId) {
    const {code, list} = await this.$http('smarthos.user.book.doc.list', {docId});
    if (code === '0') return list;
    return [];
  }

  /**
   * 专家排班
   * @param docId
   * @param hosId
   * @returns {Promise<void>}
   */
  async yspbinfo({docId, hosId}) {
    const {code, obj = {}} = await this.$http('smarthos.yygh.ApiDoctorService.yspbinfo', {
      hosId, docId
    });
    return code === '0' ? obj : {};
  }

  /**
   * 加号安排时间
   * @returns {Promise<Array>}
   */
  async arrangeTime() {
    const {code, list} = await this.$http('smarthos.appointment.arrange.time', {})
    return code === '0' ? list : [];
  }

  /***
   *  查询号源
   */
  async selectNum(data){
    const {code,list} = await this.$http('smarthos.yygh.apiQueryNumberService.selectNum',data);
    return code == '0' ? list : [];
  }

  /***
   *  预约挂号
   */
  async yygh(data){
    const {code,obj} = await this.$http('smarthos.yygh.apiOrderService.teleMedicineRegister',data);
    return code == '0'
  }
}

export const bookService = new BookService();
